import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { GIButton, Modal } from 'app-components';
import { GIFormLabel } from '../../../components/common/app-components/GIInput';

import { ModalContextType } from '../../../contexts/modalContext';
import CapitalizedButton from '../components/common/CapitalizedButton';



interface IModalProps extends ModalContextType {
    terminationDateOptions: string[],
    setTerminationDate: (terminationDate: string) => void
}

export default function ChangeTerminationDate({ terminationDateOptions, setTerminationDate, closeModal }: IModalProps) {

    const intl = useIntl();
    const [selectedOption, setSelectedOption] = useState('');
    function onClose(e) {
        e?.preventDefault();
        closeModal('changeTerminationDate');
    }

    const handleDateSelect = (e) => {
        if (e.target.value != -1) {
            setSelectedOption(e.target.value);
        } else {
            setSelectedOption('');
        }
    };

    const submitButtonHandler = () => {
        setTerminationDate(selectedOption);
        closeModal('changeTerminationDate');
    }

    return (
        <Modal id="changeTerminationDateModal">
            <Modal.Header id="ChangeTerminationDateModalHeader" titleId="indportal.enrollments.changeCoverageEndDate" onHide={onClose} />
            <Modal.Body id="ChangeTerminationDateModalBody">
                <div className="control-group">
                    <GIFormLabel name='hardExemption' id='change_your_termination_date' required>
                        <FormattedMessage id='indportal.enrollments.changeYourTerminationDate' />
                    </GIFormLabel>
                    <br />
                    <select id="change_your_termination_date" className={selectedOption ? '' : 'border-danger'} onChange={handleDateSelect} required>
                        <option key={-1} value={-1}>{intl.formatMessage({ id: 'indportal.enrollments.selectTerminationDate' })}</option>
                        {
                            terminationDateOptions.map((date) => {
                                return (
                                    <option key={date} value={date}>{date}</option>
                                )
                            })
                        }
                    </select>
                </div>
            </Modal.Body>
            <Modal.Controls>
                <CapitalizedButton 
                    id="changeTerminationDateModalCancelButton" 
                    onClickHandler={onClose} 
                    variant="secondary" 
                    labelId="button.cancel" 
                />
                <CapitalizedButton 
                    id="changeTerminationDateModalSubmitButton" 
                    labelId='button.submit' 
                    isDisabled={!selectedOption} 
                    onClickHandler={submitButtonHandler} 
                    leftMargin={true} 
                />
            </Modal.Controls>
        </Modal>
    );
}